import { Component, Input, ElementRef, OnInit, OnDestroy, OnChanges } from '@angular/core';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements OnInit, OnDestroy, OnChanges {
  @Input() src?: string; // URL do vídeo
  @Input() index?: number; // Índice do slide onde o vídeo está
  @Input() currentIndex?: number; // Índice atual do slide ativo

  private videoElement?: HTMLVideoElement;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.videoElement = this.el.nativeElement.querySelector('video');
    this.checkAndPlayOrPause();
  }

  ngOnChanges() {
    this.checkAndPlayOrPause();
  }

  ngOnDestroy() {
    this.pauseVideo();
  }

  private checkAndPlayOrPause() {
    if (this.index === this.currentIndex) {
      this.playVideo();
    } else {
      this.pauseVideo();
    }
  }

  private playVideo() {
    if (this.videoElement) {
      this.videoElement.play().catch(error => console.error('Error playing video:', error));
    }
  }

  private pauseVideo() {
    if (this.videoElement) {
      this.videoElement.pause();
    }
  }
}
